import * as Types from '../../types/graphql.gen';

import { gql } from '@apollo/client';
export type CreditCardUnitFragment = { __typename?: 'CreditCard', brand: string, expMonth: number, expYear: number, last4: string, name: string | null, stripeObjectId: string };

export const CreditCardUnitFragmentDoc = gql`
    fragment CreditCardUnit on CreditCard {
  brand
  expMonth
  expYear
  last4
  name
  stripeObjectId
}
    `;